import { ApiResponse } from '../api'
import { axios } from '@src/lib/axios'

type FactoryStatisticsDto = {
  /** 廠區代碼 */
  code: string;
  /** 描述 */
  description: string;
  /** 統計資料 */
  statistics: {
    /** 已完成組裝 */
    completed: number;
    /** 已完成品檢 */
    checked: number;
    /** 組裝中 */
    assembling: number;
    /** 品檢中 */
    checking: number;
  };
}


export type StatisticsRespDto = FactoryStatisticsDto[]

/** 取得工位清單 */
export async function getStatistics(): Promise<StatisticsRespDto> {
  const response = await axios.get<ApiResponse<StatisticsRespDto>>('/api/web/dashboard/statistics')

  return response.data;
}
  
  